// Componente para enviar ubicación (versión web).
// Usa la API de geolocalización del navegador.
// Adaptado para web desde amarsi-app (React Native a React DOM).

import React, { useState, useCallback } from 'react';
import { FiMapPin, FiX } from 'react-icons/fi';

export default function EnviarUbi({ onSendLocation, onClose }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Obtiene la ubicación actual del usuario
  const handleGetCurrentLocation = useCallback(async () => {
    if (!navigator.geolocation) {
      setError('Tu navegador no soporta geolocalización');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const position = await new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(
          resolve,
          reject,
          {
            enableHighAccuracy: true,
            timeout: 10000,
            maximumAge: 0,
          }
        );
      });

      const location = {
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
      };

      // Llama al callback con la ubicación
      if (onSendLocation) {
        onSendLocation(location);
      }
      
      onClose();
    } catch (err) {
      console.error('Error obteniendo ubicación:', err);
      setError('No se pudo obtener tu ubicación. Verifica los permisos.');
    } finally {
      setLoading(false);
    }
  }, [onSendLocation, onClose]);

  return (
    <div className="bg-gray-800 rounded-lg p-4 max-w-sm">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-white text-lg font-semibold">Compartir ubicación</h3>
        <button
          onClick={onClose}
          className="text-gray-400 hover:text-white transition-colors"
        >
          <FiX size={20} />
        </button>
      </div>

      <div className="space-y-3">
        <button
          onClick={handleGetCurrentLocation}
          disabled={loading}
          className="w-full bg-primary hover:bg-primary/80 text-white p-3 rounded-lg flex items-center justify-center gap-2 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <FiMapPin size={20} />
          {loading ? 'Obteniendo ubicación...' : 'Usar mi ubicación actual'}
        </button>

        {error && (
          <p className="text-red-400 text-sm text-center">{error}</p>
        )}

        <p className="text-gray-400 text-xs text-center">
          Se compartirá tu ubicación actual
        </p>
      </div>
    </div>
  );
}
